import React from "react";
import { Button } from "react-bootstrap";

function ConfirmBox({ heading, message, confirmAction, resetCallback }) {
  return (
    <>
      <div
        style={{
          position: "fixed",
          inset: 0,
          backgroundColor: "rgba(0,0,0,0.55)",
          zIndex: 9998,
        }}
        onClick={() => resetCallback(false)}
      />
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 9999,
          background: "#fff",
          borderRadius: 10,
          minWidth: 320,
          maxWidth: 480,
          width: "90%",
          boxShadow: "0 12px 48px rgba(0,0,0,0.25)",
          overflow: "hidden",
        }}
      >
        <div style={{ backgroundColor: "#2d543e", color: "#fff", padding: "14px 20px" }}>
          <h5 style={{ margin: 0, fontSize: "1rem", fontWeight: 600 }}>{heading}</h5>
        </div>
        <div style={{ padding: "20px" }}>
          <p style={{ margin: 0, fontSize: "0.95rem", color: "#333" }}>{message}</p>
        </div>
        <div style={{ padding: "0 20px 16px", display: "flex", gap: 8, justifyContent: "flex-end" }}>
          <Button
            variant="danger"
            onClick={() => { confirmAction(); resetCallback(false); }}
          >
            Confirm
          </Button>
          <Button variant="secondary" onClick={() => resetCallback(false)}>
            Cancel
          </Button>
        </div>
      </div>
    </>
  );
}

export default ConfirmBox;
